export const cacheKeys = {
  getMeetings: 'getMeetings',
  getMeeting: 'getMeeting',
  createMeeting: 'createMeeting',
  editMeeting: 'editMeeting',
  deleteMeeting: 'deleteMeeting',
};
